import { MenuItem } from "@/app/ui/navigation/types";
import { dutySchemeType } from "@/components/pages/duty/composables/dutyConfiguration";
import type { Location } from "vue-router";
import { LocalDate } from "@js-joda/core";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const dutyMenuNz = {
  root: "navigation_duty_group_nz",
  audit: "duty_audit_report",
  viewAudit: (fromDate: LocalDate, toDate: LocalDate): Location => ({
    name: dutyMenuNz.audit,
    params: {
      fromDateInclusive: fromDate.toString(),
      toDateInclusive: toDate.toString(),
    },
  }),
};

export const buildDutyMenuNzItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: dutyMenuNz.root,
    icon: "Assignment",
    visible: () =>
      dutySchemeType.value.isNz() &&
      hasPermissionsUsingUserStore([EnumUserPermission.menuDutyView]),
    subMenus: [
      MenuItem.fromOpts({
        name: dutyMenuNz.audit,
        url: "/duty/nz/audit",
        componentProps: (r) => ({
          fromDateInclusive:
            r.params.fromDateInclusive &&
            LocalDate.parse(r.params.fromDateInclusive),
          toDateInclusive:
            r.params.toDateInclusive &&
            LocalDate.parse(r.params.toDateInclusive),
        }),
        view: () =>
          import(
            /* webpackChunkName: "nz-duty" */ "@/components/pages/duty/nz/DutyAudit.vue"
          ),
      }),
    ],
  }),
];
